import { useAuth0 } from "@auth0/auth0-react";
import { IconButton, TableContainer } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Pagination from "@material-ui/lab/Pagination";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import { ReactComponent as PayNowSvg } from "assets/icons/Property.svg";
import sortImg, { ReactComponent as SortAbleSvg } from "assets/icons/sort-able-svg.svg";
import { MyCheckbox } from "components";
import AlertDialog from "components/Dialog/index";
import MyButton from "components/MyButton";
import RightDrawer from "components/drawer";
import Loader from "components/loader/Loader";
import { debounce } from "lodash";
import React, { memo, useCallback, useEffect, useState } from "react";
import { BsSortDown } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useHistory, useLocation } from "react-router-dom";
import FinanceService from "../../Lib/API/Finance";
import ExportOptions from "../../components/ExportOptions/ExportOptions";
import { dispatchPayAllValue } from "../../store/redux/actions";
import {
  HidePaymentInfoButton,
  dispacthPayNowRow,
} from "../../store/redux/actions/index";
import ShareDocumentsModal from "./Documents/ShareDocumentsModal/index";
import FinanceDrawer from "./Drawer";
import ExpandableRow from "./TransationTableComponents/ExpandableRow";
import { chargeColumns, paymentColumns, accountColumns } from './exportColumns';

import MyModal from "components/MyModal";
import NewDialog from "components/NewDialog/Dialog";
import UpdatePaymentMethod from "components/UpdatePaymentMethod/index";
import Button from "components/button/Button";
import ClearGroupFilter from "components/clearGroupFilter/index";
import { formatDate } from "helper/dateFormat";
import { numberFormat } from "helper/numberFormat";
import * as XLSX from "xlsx";
import { sanitizeRows } from "utils/exportSanitize";
import { formatPhoneNumber } from 'react-phone-number-input';
import { fontConfig } from "theme/fontConfig";



const ChargesTable = ({
  checkbatchBillingTable = false,
  rowsPerPage,
  batchbillingShow,
  page,
  setRowsPerPage,
  setPage,
  filters,
  setGoSetting,
  goSetting,
  sortData,
  sortCharged,
  list,
  batchDataCount,
  setBatchDataCount,
  batchTable,
  filter,
  paymentExpandable,
  setPaymentExpandable,
  setBatchList,
  batchList,
  resetChecks,
  setResetchecks,
  finance,
  tableModel,
  setTableModel,
  loading,
  setLoading,
  switchType,
  setSwitchType,
  bulkPayment,
  viewDocumentHandler,
  downloadFileHandler,
  documentHandler,
  exportChargeData,
  setExportChargeData,
  exportPaymentData,
  setExportPaymentData,
  restChargePaymentFilter,
  viewLetterHandler,
  showTabs,
  isEmbeddedInDialog = false,
  showPagination=true,
  showSelection=true,
  showAccountName=true,
}) => {
  const organization = localStorage.getItem('organization')
    ? JSON.parse(localStorage.getItem('organization'))
    : null;
  const orgKey = organization?.orgkey;

  const tableContainerRef = React.useRef(null);
  const confirmEditTransaction = React.useRef(false);
  const latestRequestId = React.useRef(0);


  const location = useLocation();
  const history = useHistory();

  const searchParams = new URLSearchParams(location?.search);
  const chargeIdParams = searchParams.get("chargeId");

  const [openModal, setOpenModal] = React.useState(false);
  const [openModalDialog, setOpenModalDialog] = React.useState(false);
  const [selectionModel /* setSelectionModel */] = React.useState([]);
  const [drawerData, setDrawerData] = useState({});
  const [currentAccount, setCurrentAccount] = useState(null);
  const [financeCheckIds, setFinanceCheckIds] = useState([]);
  const [check, setCheck] = useState([]);
  const { getAccessTokenSilently } = useAuth0();
  const [productData, setProductData] = useState();
  const [count, setCount] = useState();
  const [checkData, setCheckData] = useState([]);
  const [savetribute, setsavetribute] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [search_item_id, setSearch_item_id] = useState(null);
  const dispatch = useDispatch();
  const [paymentAction, setPaymentAction] = useState(false);
  const [isCountLoading, setIsCountLoading] = useState(false);
  const [openSharePaymentModal, setOpenSharePayment] = useState(false)
  const [dataRowSharePayment, setDataRowSharePayment] = useState({})
  const [isExportLoading, setIsExportLoading] = useState(false)
  const [isExportEnable, setIsExportEnable] = useState(false)
  const [openConfirmEditInstallmentModal, setOpenConfirmEditInstallmentModal] = useState(false);
  const [transactionRowData, setTransactionRowData] = useState({});
  const [openConfirmCancelInstallmentModal, setOpenConfirmCancelInstallmentModal] = useState(false);
  const [cancelInstallmentLoading, setCancelInstallmentLoading] = useState(false);
  const [copyPaymentLink, setCopyPaymentLink] = useState("");
  const [updatePaymentMethod, setUpdatePaymentMethod] = useState({
    open: false,
    data: null,
  });
  const RecurringModelCheck = useSelector(
    (state) => state.homeReducer.RecurringModelCheck
  );
  const [bulkSort, setBulkSort] = useState({});

  const handleBulkSort = (name) => {
    setBulkSort((prev) => ({
      [name]: prev[name] === 1 ? -1 : 1,
    }));
  };

  useEffect(() => {
    setCheckData([]);
    setCheck([]);
    setFinanceCheckIds([]);
    setCurrentAccount(null);
  }, [batchList]);

  useEffect(() => {
    if (resetChecks == true) {
      setCheckData([]);
      setCheck([]);
      setResetchecks(false);
    }
  }, [resetChecks]);

  useEffect(() => {
    setCheck([]);
    setCheckData([]);
    setFinanceCheckIds([]);
    setCurrentAccount(null);
  }, [switchType, filters.status, filters?.filter?.charge_type, filters?.filter?.id, filters?.search]);

  useEffect(() => {
    setPage(0);
  }, []);

  const clearFilterHandler = () => {
    getTransactionApiHandler(true);
    fetchCount(true);
  }


  const [checkCreateAccount, setcheckCreateAccount] = useState(false);

  const getTransactionApiHandler = async (clearParams = false) => {
    const myId = ++latestRequestId.current;

    const chargeTabs = ["All", "Charge", "Payment", "COA"]
    if (
      checkbatchBillingTable &&
      filters?.filter?.batch_billing === undefined
    ) {
      return;
    }
    setIsExportEnable(false);
    setLoading(true);
    setResetchecks(false);
    const token = await getAccessTokenSilently();
    const filterClone = { ...filters };
    if (chargeIdParams && !clearParams) {
      filterClone.search = chargeIdParams;
    }
    const keys = Object.keys(filters);
    if (filters?.filter?.id?.length === 0) delete filters.filter.id;
    if (filters?.filter?.amount?.length === 0) delete filters.filter.amount;

    // if (keys.length === 2 && !checkbatchBillingTable) {
    filters = {
      ...filters,
      filter: {
        ...filters?.filter,
        hidden: true,
      },
    };
    // }
    const isStatusIncluded = chargeTabs?.map(item => item?.toLowerCase()).includes(filter?.status?.toLowerCase());

    const updatedFilter = {
      ...filters,
      status: isStatusIncluded ? filters?.status : undefined,
    }

    const payload = (chargeIdParams && !clearParams) ? filterClone : updatedFilter;

    await FinanceService.getAllTransactionsEnhance(
      token,
      page + 1,
      rowsPerPage,
      payload
    )
      .then((res) => {
        if (myId !== latestRequestId.current) return;
        const result = res?.payload?.data;
        if (chargeIdParams && !clearParams) {
          modifyRowData(
            result?.[0],
            result?.[0]?.charge?.payment?.History?.[0]
          );
        }
        setProductData(result);
        // setCheckData([]);
        // result?.[0]?.charge?.payment?.History?.[0];
        setLoading(false);
        setGoSetting(0);
        setSwitchType("charge");

        checkEnableExport(result);
      })
      .catch((error) => {
        if (myId !== latestRequestId.current) return;
        toastr.error(error?.data?.message);
        setLoading(false);
      });

  };

  const getBulkPayments = async (page) => {
    setIsExportEnable(false);
    setProductData([]);
    const token = await getAccessTokenSilently();
    const payload = {
      filter: {
        ...filters?.filter,
        method: "all",
        charge_type: filters?.filter?.charge_type
          ? filters?.filter?.charge_type
          : undefined,
        id: filters?.filter?.id ? filters?.filter?.id : undefined,
        amount: filters?.filter?.amount ? filters?.filter?.amount : undefined,
      },
      sort: bulkSort,
    };
    try {
      setLoading(true);
      const res = await FinanceService.getBulkPaymentData(
        token,
        page + 1,
        30,
        payload
      );
      const result = res?.payload?.data;
      setProductData(result);
      checkEnableExport(result);
      setGoSetting(0);
    } catch (error) {
      toastr.error("Error", error?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const getBulkPaymentsCount = async () => {
    const token = await getAccessTokenSilently();
    const payload = {
      filter: {
        ...filters?.filter,
        method: "all",
        charge_type: filters?.filter?.charge_type
          ? filters?.filter?.charge_type
          : undefined,
        id: filters?.filter?.id ? filters?.filter?.id : undefined,
        amount: filters?.filter?.amount ? filters?.filter?.amount : undefined,
      },
      sort: bulkSort,
    };
    try {
      setIsCountLoading(true);
      const res = await FinanceService.getBulkPaymentCount(
        token,
        page + 1,
        30,
        payload
      );
      setCount(res?.payload?.pagination?.count);
    } catch (error) {
      toastr.error("Error", error?.data?.message);
    } finally {
      setIsCountLoading(false);
    }
  };

  const fetchCount = async (clearParams = false) => {
    try {
      setIsCountLoading(true);
      if (
        checkbatchBillingTable &&
        filters?.filter?.batch_billing === undefined
      ) {
        return;
      }
      const token = await getAccessTokenSilently();
      const filterClone = { ...filters };
      if (chargeIdParams && !clearParams) {
        filterClone.search = chargeIdParams;
      }
      const keys = Object.keys(filters);
      if (filters?.filter?.id?.length === 0) delete filters.filter.id;
      if (filters?.filter?.amount?.length === 0) delete filters.filter.amount;

      // if (keys.length === 2 && !checkbatchBillingTable) {
      filters = {
        ...filters,
        filter: {
          ...filters?.filter,
          hidden: true,
        },
      };
      // }
      const res = await FinanceService.getTransactionsCount(
        token,
        1,
        30,
        (chargeIdParams && !clearParams) ? filterClone : filters
      );
      setCount(res?.payload?.pagination?.count);
    } catch (e) {
      toastr.error("Error", e?.data?.message);
    } finally {
      setIsCountLoading(false);
    }
  };

  useEffect(() => {
    if (!location?.pathname?.includes("/finance")) return;
    if (switchType === "payment") {
      getBulkPaymentsCount();
    } else {
      if (!chargeIdParams) {
        fetchCount();
      }
    }
  }, [goSetting, filters?.status, filters?.filter?.charge_type, switchType]);

  const checkEnableExport = (result) => {
    const isFilterApplied = checkIfAnyFilterApplied()
    if (isFilterApplied && result?.length) {
      setIsExportEnable(true);
    }
    else {
      setIsExportEnable(false);
    }
  }

  useEffect(() => {
    const param = new URLSearchParams(location.search).get("q");
    if (!param) return;
    setSearch_item_id(param);
  }, [location.search]);


  useState(() => {
    if (!checkbatchBillingTable) {
      setProductData([]);
    }
  }, [goSetting]);





  useEffect(() => {
    if (switchType !== "payment" || !location?.pathname?.includes("/finance")) return;
  }, [
    switchType,
    page,
    filters.status,
    filters?.filter?.charge_type,
    bulkSort,
    checkCreateAccount,
  ]);

  useEffect(() => {
    if (switchType !== "charge" || !location?.pathname?.includes("/finance") || goSetting || chargeIdParams) return;
    getTransactionApiHandler();
  }, [
    switchType,
    page,
    filters.status,
    filters?.filter?.charge_type,
    bulkSort,
    checkCreateAccount,
    savetribute,
    batchList,
    RecurringModelCheck,
  ]);


  useEffect(() => {
    if (switchType !== "payment" || !location?.pathname?.includes("/finance")) return;
    getBulkPayments(page);
  }, [
    page,
    filters.status,
    filters?.filter?.charge_type,
    bulkSort,
    checkCreateAccount,
    switchType,
  ]);




  useEffect(() => {
    if (switchType !== "charge") return;
    if (chargeIdParams || Object.keys(filters?.sort)?.length > 0 || goSetting || paymentAction || tableModel) {
      getTransactionApiHandler();
      fetchCount();
      if (paymentAction) setPaymentAction(false);
    }
  }, [chargeIdParams, filters?.sort, goSetting, switchType, paymentAction]);

  useEffect(() => {
    if (switchType !== "payment") return;
    if (goSetting) {
      getBulkPayments(page);
    }
  }, [goSetting]);

  function handleSaveTransaction() {
    getTransactionApiHandler();
    fetchCount();
  }

  useEffect(() => {
    window.addEventListener("save-transaction", handleSaveTransaction);
    return () => {
      window.removeEventListener("save-transaction", handleSaveTransaction);
    };
  }, [filters, sortData, page, getAccessTokenSilently]);

  const onChargeEditClick = () => {
    setCheckData([]);
    setCheck([]);
  };

  useEffect(() => {
    document.addEventListener("edit-charge", onChargeEditClick);
    return () => document.removeEventListener("edit-charge", onChargeEditClick);
  }, []);

  const onPayNowClick = (row) => {
    dispatch(dispacthPayNowRow(row));
    document.dispatchEvent(new CustomEvent("pay-now", { detail: row }));
  };

  const onUpdatePaymentMethodClick = (row) => {
    setUpdatePaymentMethod({ open: true, data: row });
  };

  const closeUpdatePaymentMethod = () => {
    setUpdatePaymentMethod({ open: false, data: null });
  };

  const mainUrl = window.location.origin;
  const getPaymentLink = (id) => {
    const checkDomain =
      mainUrl === 'https://admin.eztmpl.dev' ||
        mainUrl === 'http://localhost:3000'
        ? `https://shalom.eztmpl.dev/charges?accountId=${id}`
        : mainUrl === 'https://admin.eztmpl.com'
          ? `https://demo.eztmpl.com/charges?accountId=${id}`
          : mainUrl === 'https://admin.easyshul.com'
            ? `https://${orgKey}.easyshul.com/charges?accountId=${id}`
            : null;
    return checkDomain
  }
  // To Open share share document popUp
  const onSharePaymentLinkClick = (row) => {
    const paymentLink = row?.Account?.id ? getPaymentLink(row?.Account?.id) : "";
    setOpenSharePayment(!openSharePaymentModal)
    setDataRowSharePayment(row)
    setCopyPaymentLink(paymentLink || "");
  }

  const handleCloseDialog = () => {
    setOpenModalDialog(false);
  };

  const [selectedRow, setSelectedRow] = useState(null);
  const [showWarningDeleteDialog, setShowWarningDeleteDialog] = useState(false);

  const onDeleteClick = async (row) => {
    const isZeroPaid = parseFloat(row?.charge?.paid) === 0;
    const isReversed =
      row?.charge?.sub_status === "reversal" ||
      row?.charge?.payment?.status === "reversal";
    const isSynced = row?.charge?.is_synced === true;
    if (isZeroPaid && isReversed) {
      setSelectedRow(row);
      setShowWarningDeleteDialog(true);
    } else {
      setOpenModalDialog(true);
      setSelectedRow(row);
    }
  };

  const handleSubmit = async () => {
    const token = await getAccessTokenSilently();
    const isRecurring = selectedRow?.isRecurring;
    await FinanceService.deleteTransaction(selectedRow, token, selectedRow?.charge?._id ?? "")
      .then((res) => {
        if (res) {
          toastr.success("Transaction deleted successfully");
          getTransactionApiHandler();
          fetchCount();
          setOpenModalDialog(false);
          setShowWarningDeleteDialog(false);
        }
      })
      .catch((err) => {
        toastr.error(err?.data?.message);
        setOpenModalDialog(false);
        setShowWarningDeleteDialog(false);
      });
  };

  const openConfirmEditInstallmentModalHandler = (row) => {
    confirmEditTransaction.current = false;
    setOpenConfirmEditInstallmentModal(true);
    setTransactionRowData(row);
  }

  const onUpdateClick = async (row) => {


    if (!confirmEditTransaction.current && row?.charge?.installmentDetails?.status === "active") {
      return openConfirmEditInstallmentModalHandler(row)
    }
    confirmEditTransaction.current = false;


    document.dispatchEvent(new CustomEvent("edit-charge", { detail: row }));
    dispatch(HidePaymentInfoButton(true));

    if (
      row.charge?.payment?.status === "partialy_applied" ||
      row.charge?.payment?.status === "close"
    ) {
      localStorage.setItem("TransStatus", "close");
    }
  };


  const onReversalClick = async (id, setReversalActionTypes) => {
    const token = await getAccessTokenSilently();
    setLoading(true);
    await FinanceService.reverseCharge(id, token)
      .then(() => {
        setLoading(false);
        toastr.success("Success", "Charge has been reversed");
      })
      .catch((error) => {
        setLoading(false);
        toastr.error(
          error?.data?.message ||
          "Something went wrong, please try again later"
        );
      });
    getTransactionApiHandler();
    setReversalActionTypes(false);
  };

  const onPayAllClick = (row) => {
    dispatch(dispatchPayAllValue(row));
    document.dispatchEvent(new CustomEvent("pay-all", { detail: row }));
  };
  /**
   * @param {React.ChangeEvent<HTMLInputElement>} e
   * @param {string} accountId
   */

  const onCheckboxChange = (e, row, index, page) => {
    setCheckData((prev) => [...prev, row]);

    const { checked } = e.target;
    if (!checked) {
      setCheck((prev) => {
        const checkClone = prev.filter((item) => item !== row?.charge?._id);
        if (!checkClone.length) {
          setCurrentAccount(null);
        }
        return [...checkClone];
      });

      setCheckData((prev) => {
        const checkClone = prev.filter(
          (item) => item?.charge?._id !== row?.charge?._id
        );
        if (!checkClone.length) {
          setCurrentAccount(null);
        }
        return [...checkClone];
      });
      return;
    }

    setCheck((prev) => [...prev, row?.charge?._id]);
    setFinanceCheckIds((prev) => [...new Set([...prev, row?.Account?.id])]);
    if (!currentAccount) setCurrentAccount(row?.Account?.id);
  };


  const onCancelPayment = (row) => {
    setOpenConfirmCancelInstallmentModal(true);
    setTransactionRowData(row);
  }

  const confirmCancelInstallmentHandler = async () => {
    if (cancelInstallmentLoading) return;
    setCancelInstallmentLoading(true);
    const token = await getAccessTokenSilently();
    const payload = {
      installmentId: transactionRowData?.charge?.installmentDetails?.installmentId,
      chargeId: transactionRowData?.charge?._id,
    }

    await FinanceService.cancelInstallment(token, payload)
      .then((res) => {
        if (res) {
          setOpenConfirmCancelInstallmentModal(false);
          toastr.success("Success", "Installment Cancelled Successfully");
          getTransactionApiHandler();
          fetchCount();
        }
      })
      .catch((error) => {
        toastr.error(error?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setCancelInstallmentLoading(false);
      });
  }



  const modifyRowData = (row, item) => {
    const modified = { ...row, charge: { ...row.charge }, ...item, transactionId: row?._id };
    setDrawerData(modified);
    setOpenModal(true);
    // const newLocation = { ...location, search: "" };
    // history.replace(newLocation);
  };

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  const checkIfAnyFilterApplied = () => {
    let isAnyFilterApplied = false;
    const { filter, status } = filters;
    if (filter !== undefined) {
      const { hidden, charge_type, ...filterClone } = filter;
      if (filterClone?.id && filterClone?.id?.length !== 24) return isAnyFilterApplied = false;
      isAnyFilterApplied = Object.values(filterClone).some(value => {
        if (value !== undefined) {
          if (Array.isArray(value)) {
            return value.length > 0;
          } else if (typeof value === 'object') {
            return Object.values(value).some(value => value !== undefined);
          } else if (typeof value === 'string') {
            return value.length > 0;
          } else if (typeof value === 'number') {
            return value >= 0;
          } else if (typeof value === 'boolean') {
            return value;
          }
        }
      });
    }
    return isAnyFilterApplied
  }



  const getExportChargeDataHandler = async (addAccounts = false) => {
    const chargeTabs = ["All", "Charge", "Payment", "COA"]
    setExportChargeData({});
    if (
      checkbatchBillingTable &&
      filters?.filter?.batch_billing === undefined
    ) {
      return;
    }
    if (filters?.filter?.includeAccountInformation && addAccounts) {
      headerColumns = [...headerColumns, ...accountColumns];
    }
    let exportChargeData = [];
    const token = await getAccessTokenSilently();
    const { sort, ...filterClone } = { ...filters };
    if (chargeIdParams) {
      filterClone.search = chargeIdParams;
    }
    const keys = Object.keys(filters);
    if (filters?.filter?.id?.length === 0) delete filters.filter.id;
    if (filters?.filter?.amount?.length === 0) delete filters.filter.amount;
    filters = {
      ...filters,
      filter: {
        ...filters?.filter,
        hidden: true,
      },
    };
    const isStatusIncluded = chargeTabs?.map(item => item?.toLowerCase()).includes(filter?.status?.toLowerCase());

    const updatedFilter = {
      ...filters,
      status: isStatusIncluded ? filters?.status : undefined,
    }
    console.log("updatedFilter", updatedFilter);
    await FinanceService.getExportTransactionsEnhance(
      token,
      chargeIdParams ? filterClone : updatedFilter
    )
      .then((res) => {
        const result = res?.data?.length ? res?.data?.[0] : [];
        setExportChargeData(result);
        // console.log("exportChargeData", result);
        exportChargeData = result;
      })
      .catch((error) => {
        toastr.error(error?.data?.message);
      }).finally(() => {
      });

    return exportChargeData;
  };

  const getExportPaymentsDataHandler = async (addAccounts = false) => {
    let exportPaymentData = [];
    setExportPaymentData({});
    if (filters?.filter?.includeAccountInformation && addAccounts) {
      headerColumns = [...headerColumns, ...accountColumns];
    }
    const token = await getAccessTokenSilently();
    const payload = {
      filter: {
        ...filters?.filter,
        method: "all",
        charge_type: filters?.filter?.charge_type
          ? filters?.filter?.charge_type
          : undefined,
        id: filters?.filter?.id ? filters?.filter?.id : undefined,
        amount: filters?.filter?.amount ? filters?.filter?.amount : undefined,
      },
    };
    try {
      const res = await FinanceService.getExportBulkPaymentData(
        token,
        payload
      );
      const result = res?.data?.records?.length ? res?.data : [];
      setExportPaymentData(result);
      exportPaymentData = result;
    } catch (error) {
      toastr.error("Error", error?.data?.message);
    } finally {
    }
    return exportPaymentData;
  };




  const chargeExportData = useCallback((resultData, addAccounts = false) => {
    const chargeData = [];
    if (!resultData?.records?.length) return chargeData;
    resultData.records.forEach((product) => {
      const base = {
        numericAccountId: product?.numericAccountId,
        transactionId: product?._id,
        chargeId: product?.chargeId,
        accountName: product?.accountName,
        ledgerName: product?.ledgerName,
        subLedgerName: product?.subLedgerName,
        dueDate: product?.dueDate ? formatDate({ date: product?.dueDate, formatType: "default" }) : "",
        amount: numberFormat({ number: +product?.amount, decimal: 2, style: "decimal" }),
        discount: numberFormat({ number: +product?.discount, decimal: 2, style: "decimal" }),
        paid: numberFormat({ number: +product?.paid, decimal: 2, style: "decimal" }),
        amountDue: numberFormat({ number: +product?.amountDue, decimal: 2, style: "decimal" }),
        invoiceNote: product?.comment_invoice?.note ?? "",
      };

      const accountInfo = addAccounts ? {
        mailFamilyName: product?.account?.MailFamilyName,
        address1: product?.account?.Address1,
        address1Line2: product?.account?.Address1_Line2,
        address1City: product?.account?.Address1_City,
        address1State: product?.account?.Address1_State,
        address1ZipCode: product?.account?.Address1_Zip_Code,
        address1Country: product?.account?.Address1_Country,
        adult1FirstName: product?.account?.['Adult 1 First Name'],
        adult1LastName: product?.account?.['Adult 1 Last Name'],
        adult1NickName: product?.account?.['Adult 1 NickName'],
        adult1Mobile: product?.account?.['Adult 1 Mobile'] ? formatPhoneNumber(product?.account?.['Adult 1 Mobile']) : "",
        adult1Email: product?.account?.['Adult 1 Email'],
        adult1Title: product?.account?.['Adult 1 Title'],
        adult2Title: product?.account?.['Adult 2 Title'],
        adult2FirstName: product?.account?.['Adult 2 First Name'],
        adult2LastName: product?.account?.['Adult 2 Last Name'],
        adult2NickName: product?.account?.['Adult 2 Nick Name'],
        adult2Mobile: product?.account?.['Adult 2 Mobile'] ? formatPhoneNumber(product?.account?.['Adult 2 Mobile']) : "",
        adult2Email: product?.account?.['Adult 2 Email'],
        currentPhone: product?.account?.Current_Phone ? formatPhoneNumber(product?.account?.Current_Phone) : "",
        familyName: product?.account?.FamilyName,
        memberFamilyId: product?.account?.Member_FamilyID,
        mailFamilyName: product?.account?.mailLabelName || product?.account?.MailFamilyName,
        billing_category: product?.account?.billing_category,
        join_date: product?.account?.join_date,
        anniversary: product?.account?.anniversary,
      } : {};

      chargeData.push({ ...base, ...accountInfo });
    });
    const total = {
      numericAccountId: "",
      chargeId: "Total",
      accountName: `${resultData?.totalRecords}`,
      ledgerName: "",
      subLedgerName: "",
      dueDate: "",
      amount: numberFormat({ number: +resultData?.totalAmount, decimal: 2, style: "decimal" }),
      discount: numberFormat({ number: +resultData?.totalDiscount, decimal: 2, style: "decimal" }),
      paid: numberFormat({ number: +resultData?.totalPaid, decimal: 2, style: "decimal" }),
      amountDue: numberFormat({ number: +resultData?.totalAmountDue, decimal: 2, style: "decimal" }),
    }
    chargeData.push(total)
    return chargeData;
  }, []);

  const paymentExportData = useCallback((resultData, addAccounts = false) => {
    const paymentData = [];
    if (!resultData?.records?.length) return paymentData;

    resultData.records.forEach((product) => {
      const base = {
        numericAccountId: product?.numericAccountId,
        paymentId: product?.paymentId,
        chargeId: product?.chargeId,
        accountName: product?.accountName,
        ledgerName: product?.ledgerName,
        subLedgerName: product?.subLedgerName,
        paidDate: product?.paidDate ? formatDate({ date: product?.paidDate, formatType: "default" }) : "",
        amount: numberFormat({ number: +product?.amount, decimal: 2, style: "decimal" }),
        paymentMethod: product?.method,
        amountDue: numberFormat({ number: +product?.amountDue, decimal: 2, style: "decimal" }),
        receiptNote: product?.comment_receipt?.note ?? "",
      };

      const accountInfo = addAccounts ? {
        mailFamilyName: product?.account?.mailLabelName || product?.account?.MailFamilyName,
        address1: product?.account?.Address1,
        address1Line2: product?.account?.Address1_Line2,
        address1City: product?.account?.Address1_City,
        address1State: product?.account?.Address1_State,
        address1ZipCode: product?.account?.Address1_Zip_Code,
        address1Country: product?.account?.Address1_Country,
        adult1FirstName: product?.account?.['Adult 1 First Name'],
        adult1LastName: product?.account?.['Adult 1 Last Name'],
        adult1NickName: product?.account?.['Adult 1 NickName'],
        adult1Mobile: product?.account?.['Adult 1 Mobile'] ? formatPhoneNumber(product?.account?.['Adult 1 Mobile']) : "",
        adult1Email: product?.account?.['Adult 1 Email'],
        adult1Title: product?.account?.['Adult 1 Title'],
        adult2Title: product?.account?.['Adult 2 Title'],
        adult2FirstName: product?.account?.['Adult 2 First Name'],
        adult2LastName: product?.account?.['Adult 2 Last Name'],
        adult2NickName: product?.account?.['Adult 2 Nick Name'],
        adult2Mobile: product?.account?.['Adult 2 Mobile'] ? formatPhoneNumber(product?.account?.['Adult 2 Mobile']) : "",
        adult2Email: product?.account?.['Adult 2 Email'],
        currentPhone: product?.account?.Current_Phone ? formatPhoneNumber(product?.account?.Current_Phone) : "",
        familyName: product?.account?.FamilyName,
        memberFamilyId: product?.account?.Member_FamilyID,
        billing_category: product?.account?.billing_category,
        join_date: product?.account?.join_date,
        anniversary: product?.account?.anniversary,
      } : {};

      paymentData.push({ ...base, ...accountInfo });
    });

    const total = {
      paymentId: "Total",
      chargeId: `${resultData?.totalRecords}`,
      accountName: "",
      ledgerName: "",
      subLedgerName: "",
      paidDate: "",
      amount: numberFormat({ number: +resultData?.totalAmount, decimal: 2, style: "decimal" }),
      paymentMethod: "",
    };
    paymentData.push(total);
    return paymentData;
  }, []);

  const exportColumnsHandler = useCallback(() => {
    var columns = switchType === "charge" ? chargeColumns : paymentColumns;
    return columns;
    // return filters?.filter?.includeAccountInformation ? [...columns, ...accountColumns] : columns;
  }, [switchType, filters?.filter?.includeAccountInformation]);

  const exportDataHandler = useCallback((resultData, addAccounts = false) => {
    return switchType === "charge" ? chargeExportData(resultData, addAccounts) : paymentExportData(resultData, addAccounts);
  }, [switchType, chargeExportData, paymentExportData]);

  const getExportDataHandler = async (addAccounts = false) => {
    return switchType === "charge" ? await getExportChargeDataHandler(addAccounts) : await getExportPaymentsDataHandler(addAccounts);
  }


  const generateExcel = async () => {
    setIsExportLoading(true);
    // console.log("includeAccountInformation", filters);
    const resultData = await getExportDataHandler(filters?.filter?.includeAccountInformation);
    console.log("includeAccountInformation", filters?.filter?.includeAccountInformation);
    const exportData = exportDataHandler(resultData, filters?.filter?.includeAccountInformation)
    console.log("exportData", exportData);
    const worksheet = XLSX.utils.json_to_sheet(sanitizeRows(exportData));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(
      workbook,
      switchType === "charge" ? "Charges.xlsx" : "Payments.xlsx"
    );
    console.log("exportData", exportData);
    console.log("resultData", resultData);
    setIsExportLoading(false);
  };

  const generateCsv = async () => {
    setIsExportLoading(true);
    console.log("includeAccountInformation", filter);
    const resultData = await getExportDataHandler(filters?.filter?.includeAccountInformation);
    // console.log("resultData", resultData);
    const exportData = exportDataHandler(resultData, filters?.filter?.includeAccountInformation)
    setIsExportLoading(false);
    console.log("exportData", exportData);
    return exportData;
  }

  const printHandler = async () => {

    setIsExportLoading(true);
    const resultData = await getExportDataHandler(false);
    exportDataHandler(resultData);
  };


  const reportFileNameHandler = () => {
    return switchType === "charge" ? "Charges" : "Payments";
  }



  let headerColumns = exportColumnsHandler()

  const displayTotalCellsPrintTable = (dataRows) => {
    const chargeTotalCells = {
      ["Account ID"]: "",
      ["Charge ID"]: "Total",
      ["Account name"]: dataRows?.totalRecords,
      ["Ledger name"]: "",
      ["Sub Ledger name"]: "",
      ["Due date"]: "",
      ["Amount"]: numberFormat({ number: +dataRows?.totalAmount, decimal: 2, style: "decimal" }),
      ["Discount"]: numberFormat({ number: +dataRows?.totalDiscount, decimal: 2, style: "decimal" }),
      ["Paid"]: numberFormat({ number: +dataRows?.totalPaid, decimal: 2, style: "decimal" }),
      ["Amount Due"]: numberFormat({ number: +dataRows?.totalAmountDue, decimal: 2, style: "decimal" }),
      ["Invoice Note"]: "",
    }

    const paymentTotalCells = {
      ["Account ID"]: "",
      ["Payment ID"]: "Total",
      ["Charge ID"]: dataRows?.totalRecords,
      ["Account name"]: "",
      ["Ledger name"]: "",
      ["Sub Ledger name"]: "",
      ["Paid date"]: "",
      ["Amount"]: numberFormat({ number: +dataRows?.totalAmount, decimal: 2, style: "decimal" }),
      ["Payment Method"]: "",
      ["Receipt Note"]: "",
    }

    return switchType === "charge" ? chargeTotalCells : paymentTotalCells;
  }
  const displayCellsPrintTable = useCallback((row) => {
    const chargeCells = {
      ["Account ID"]: row?.numericAccountId,
      // ["Transaction ID"]: row?._id,
      ["Charge ID"]: row?.chargeId,
      ["Account name"]: row?.accountName,
      ["Ledger name"]: row?.ledgerName,
      ["SubLedger name"]: row?.subLedgerName,
      ["Due date"]: row?.dueDate ? formatDate({ date: row?.dueDate, formatType: "default" }) : "",
      ["Amount"]: numberFormat({ number: +row?.amount, decimal: 2, style: "decimal" }),
      ["Discount"]: numberFormat({ number: +row?.discount, decimal: 2, style: "decimal" }),
      ["Paid"]: numberFormat({ number: +row?.paid, decimal: 2, style: "decimal" }),
      ["Amount Due"]: numberFormat({ number: +row?.amountDue, decimal: 2, style: "decimal" }),
      ["Invoice Note"]: row?.comment_invoice?.note ?? "",
    }

    const paymentCells = {
      ["Account ID"]: row?.numericAccountId,
      ["Payment ID"]: row?.paymentId,
      ["Charge ID"]: row?.chargeId,
      ["Account name"]: row?.accountName,
      ["Ledger name"]: row?.ledgerName,
      ["SubLedger name"]: row?.subLedgerName,
      ["Paid date"]: row?.paidDate ? formatDate({ date: row?.paidDate, formatType: "default" }) : "",
      ["Amount"]: numberFormat({ number: +row?.amount, decimal: 2, style: "decimal" }),
      ["Payment Method"]: row?.method,
      ["Receipt Note"]: row?.comment_receipt?.note ?? "",
    }

    return switchType === "charge" ? chargeCells : paymentCells;
  }, [switchType]);
  const displayRowsPrintTable = () => {
    const dataRows = switchType === "charge" ? exportChargeData : exportPaymentData;
    const rowPrintTable =
      <>
        {dataRows?.records?.map((row) => (
          <TableRow key={row?._id}>
            {Object.values(displayCellsPrintTable(row))?.map((cell, index) => (
              <TableCell
                width="10%"
                className={"current-check main-check main-width-class "}
                key={index}
              >
                {cell}
              </TableCell>
            ))}
          </TableRow>
        ))}
        <TableRow>
          {Object.values(displayTotalCellsPrintTable(dataRows))?.map((cell, index) => (
            <TableCell
              width="10%"
              className={"current-check main-check main-width-class "}
              key={index}
            >
              {cell}
            </TableCell>
          ))}
        </TableRow>
      </>
    return rowPrintTable;
  }


  return (
    <div className="w-100">
      <div className={`family-table-container ${isEmbeddedInDialog?"":"pl-7 pr-6 pt-3 pb-22"}`}>
        <div className="home-table-container mt-0 no-box-shadow">
          <>
            <div className={`d-flex justify-content-between mb-5 ${isEmbeddedInDialog?"":" h-40px"}`}>
              <div className="d-flex align-content-center" style={{
                gap: "10px",
              }}>
                {showTabs && (
                  <div
                    className="d-flex align-items-center"
                    style={{
                      height: "36px",
                      backgroundColor: "#e7edf9",
                      borderRadius: "4px",
                    }}
                  >
                    <button
                      type="button"
                      onClick={() => {
                        if (loading) return;
                        setPage(0);
                        setSwitchType("charge");
                        restChargePaymentFilter("checkNumber")
                        // getTransactionApiHandler();
                        // fetchCount();
                      }}
                      className={
                        switchType === "charge"
                          ? `btn btn-primary m-2 d-flex align-items-center`
                          : `btn btn-clean m-2 d-flex align-items-center`
                      }
                      style={
                        switchType === "charge"
                          ? { color: "#FFFFFF", height: "24px" }
                          : { color: "#2555EF", height: "24px" }
                      }
                      disabled={loading}
                    >
                      Charges
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        if (loading) return;
                        setSwitchType("payment");
                        setPage(0);
                        restChargePaymentFilter("nonMember")
                        restChargePaymentFilter("isInstallment")
                        restChargePaymentFilter("isRecurring")
                        // getBulkPayments(0);
                        // getBulkPaymentsCount();
                      }}
                      className={
                        switchType === "payment"
                          ? `btn btn-primary m-2 d-flex align-items-center`
                          : `btn btn-clean m-2 d-flex align-items-center`
                      }
                      style={
                        switchType === "payment"
                          ? { color: "#FFFFFF", height: "24px" }
                          : { color: "#2555EF", height: "24px" }
                      }
                      disabled={loading}
                    >
                      Payments
                    </button>
                  </div>
                )}
                {(chargeIdParams && switchType === "charge") && (
                  <ClearGroupFilter text="Filtered By Charge ID" clearFilterHandler={clearFilterHandler} />
                )}
              </div>
              <div className="d-flex align-content-center" style={{
                gap: "10px",
              }}>

{isExportEnable && (
                  <ExportOptions
                    columns={filters?.filter?.includeAccountInformation ? [...headerColumns, ...accountColumns] : headerColumns}
                    datas={generateCsv}
                    downloadExcel={generateExcel}
                    isLoading={isExportLoading}
                    setLoading={setIsExportLoading}
                    tableContainerRef={tableContainerRef}
                    reportFileNameHandler={reportFileNameHandler}
                    printHandler={printHandler}

                  />
                )}
                {checkData?.some(row =>
                  !(row?.charge?.status === "payment" &&
                    row?.charge?.sub_status !== "partially_paid" &&
                    row?.charge?.sub_status !== "open") &&
                  row?.total_amount !== 0
                ) && new Set(checkData.map(r => r?.Account?.id)).size === 1 && (
                  <Button
                    variant="primary"
                    onClick={() => onPayAllClick(checkData)}
                    size="md"
                  >
                    <PayNowSvg />
                    <span>Pay All</span>
                  </Button>
                )}
              </div>
            </div>
            {checkData?.length > 0 && (() => {
              const totalCharged = checkData.reduce((sum, row) => sum + (+row?.charge?.amount || 0), 0);
              const totalPaid = checkData.reduce((sum, row) => sum + (+row?.charge?.paid || 0), 0);
              const totalDue = checkData.reduce((sum, row) => sum + ((+row?.charge?.amount || 0) - (+row?.charge?.paid || 0)), 0);
              return (
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "18px",
                  fontSize: "14px",
                  fontFamily: fontConfig.FinanceTransactionsTableTextFont.family,
                  color: "#4f4f4f",
                  marginBottom: "10px",
                  lineHeight: "1",
                }}>
                  <span style={{ fontWeight: 700, display: "inline-flex", alignItems: "center", gap: 4 }}>
                    {checkData.length} <span style={{ fontWeight: 500 }}>transactions selected</span>
                  </span>
                  <span style={{ fontWeight: 700, display: "inline-flex", alignItems: "center", gap: 4 }}>
                    <span style={{ fontWeight: 500 }}>Charged:</span>
                    {numberFormat({ number: totalCharged, decimal: 2, style: "currency" })}
                  </span>
                  <span style={{ fontWeight: 700, display: "inline-flex", alignItems: "center", gap: 4 }}>
                    <span style={{ fontWeight: 500 }}>Paid:</span>
                    {numberFormat({ number: totalPaid, decimal: 2, style: "currency" })}
                  </span>
                  <span style={{ fontWeight: 700, display: "inline-flex", alignItems: "center", gap: 4 }}>
                    <span style={{ fontWeight: 500 }}>Due:</span>
                    {numberFormat({ number: totalDue, decimal: 2, style: "currency" })}
                  </span>
                  <span
                    onClick={() => { setCheck([]); setCheckData([]); setFinanceCheckIds([]); setCurrentAccount(null); }}
                    style={{ cursor: "pointer", color: "#2555EF", fontWeight: 500, fontSize: "14px", textDecoration: "underline", display: "inline-flex", alignItems: "center" }}
                  >
                    Clear
                  </span>
                </div>
              );
            })()}
          </>
          <div className="d-none">
            <TableContainer component={Paper}>
              <Table class="main-table" aria-label="collapsible table" ref={tableContainerRef}>
                <TableHead className="charges-table">
                  <TableRow >
                    {headerColumns?.map((column) => (
                      <TableCell className="date-head" key={column?.id}
                        style={{
                          textTransform: "uppercase",
                        }}>
                        {column?.headerName}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody
                  className="tran-table-body"
                  style={{
                    backgroundColor: "white",
                    display: "contents",
                  }}
                >
                  {displayRowsPrintTable()}

                </TableBody>
              </Table>
            </TableContainer>

          </div>
          <TableContainer component={Paper} className="scroll-table" style={
    isEmbeddedInDialog
      ? {
          maxHeight: "300px",
          overflowY: "auto",
        }
      : {}
  }>
            <Table class="main-table" aria-label="collapsible table">
              <TableHead className="charges-table main-table__header sticky-table-header">
                <TableRow>
                  {showSelection && batchTable !== "batchtable" && (
  <TableCell className="table-cell-remove" />
)}
                  {/* {batchTable === "batchtable" ? (
                    <></>
                  ) : (
                    // <TableCell className="main-check" padding="checkbox">
                    //   <MyCheckbox name={"visible"} handlechange={() => { }} />
                    // </TableCell>
                    <TableCell className="table-cell-remove" />
                  )} */}
                  <TableCell className="table-cell-remove" />
                  <TableCell className="table-cell-remove" />
                  <TableCell
                    className="date-head"
                  // onClick={() => sortCharged("status")}
                  >
                    {switchType === "payment" ? "DATE" : "STATUS"}
                    {switchType !== "payment" ? (
                      <IconButton>
                        {filters?.sort?.status === 1 ? (
                          <BsSortDown onClick={() => sortCharged("status")} />
                        ) : (
                          <img
                            onClick={() => sortCharged("status")}
                            src={sortImg}
                            alt="sort"
                          />
                        )}
                      </IconButton>
                    ) : (
                      <IconButton>
                        {bulkSort?.paymentDate === 1 ? (
                          <BsSortDown
                            onClick={() => handleBulkSort("paymentDate")}
                          />
                        ) : (
                          <img
                            src={sortImg}
                            alt="sort"
                            onClick={() => handleBulkSort("paymentDate")}
                          />
                        )}
                      </IconButton>
                    )}
                  </TableCell>
                  {switchType !== "payment" && (
                    <TableCell className="status-head" align="left">
                      CREATED DATE
                      <IconButton>
                        {filters?.sort?.tran_date === 1 ? (
                          <BsSortDown
                            onClick={() => sortCharged("tran_date")}
                          />
                        ) : (
                          <img
                            onClick={() => sortCharged("tran_date")}
                            src={sortImg}
                            alt="sort"
                          />
                        )}
                      </IconButton>
                    </TableCell>
                  )}
                  <TableCell className="status-head" align="left">
                    DUE DATE
                    {switchType !== "payment" ? (
                      <IconButton>
                        {filters?.sort?.due_date === 1 ? (
                          <BsSortDown onClick={() => sortCharged("due_date")} />
                        ) : (
                          <img
                            onClick={() => sortCharged("due_date")}
                            src={sortImg}
                            alt="sort"
                          />
                        )}
                      </IconButton>
                    ) : (
                      <IconButton>
                        {bulkSort?.dueDate === 1 ? (
                          <BsSortDown
                            onClick={() => handleBulkSort("dueDate")}
                          />
                        ) : (
                          <img
                            src={sortImg}
                            alt="sort"
                            onClick={() => handleBulkSort("dueDate")}
                          />
                        )}
                      </IconButton>
                    )}
                  </TableCell>
                 {showAccountName&& ( <TableCell className="account-name" align="left">
                    <span>{"Account Name".toUpperCase()}</span>{" "}
                    {switchType !== "payment" ? (
                      <IconButton>
                        {filters?.sort?.account_name === 1 ? (
                          <BsSortDown
                            onClick={() => sortCharged("account_name")}
                          />
                        ) : (
                          <img
                            onClick={() => sortCharged("account_name")}
                            src={sortImg}
                            alt="sort"
                          />
                        )}
                      </IconButton>
                    ) : (
                      <IconButton>
                        {bulkSort?.account_name === 1 ? (
                          <BsSortDown
                            onClick={() => handleBulkSort("account_name")}
                          />
                        ) : (
                          <img
                            src={sortImg}
                            alt="sort"
                            onClick={() => handleBulkSort("account_name")}
                          />
                        )}
                      </IconButton>
                    )}
                  </TableCell>)}
                  {/* {switchType === "payment" && (
                    <TableCell className="status-head" align="left">
                      STATUS
                      <IconButton>
                        {bulkSort?.status === 1 ? (
                          <BsSortDown
                            onClick={() => handleBulkSort("status")}
                          />
                        ) : (
                          <img
                            onClick={() => handleBulkSort("status")}
                            src={sortImg}
                            alt="sort"
                          />
                        )}
                      </IconButton>
                    </TableCell>
                  )} */}
                  <TableCell className="charged-value" align="left">
                    CHARGED
                    {switchType !== "payment" ? (
                      <IconButton>
                        {filters?.sort?.charged === 1 ? (
                          <BsSortDown onClick={() => sortCharged("charged")} />
                        ) : (
                          <img
                            onClick={() => sortCharged("charged")}
                            src={sortImg}
                            alt="sort"
                          />
                        )}
                      </IconButton>
                    ) : (
                      <IconButton>
                        {bulkSort?.charged === 1 ? (
                          <BsSortDown
                            onClick={() => handleBulkSort("charged")}
                          />
                        ) : (
                          <img
                            src={sortImg}
                            alt="sort"
                            onClick={() => handleBulkSort("charged")}
                          />
                        )}
                      </IconButton>
                    )}
                  </TableCell>
                  <TableCell align="left" className="paid-head">
                    PAID
                    {switchType !== "payment" ? (
                      <IconButton>
                        {filters?.sort?.total_paid === 1 ? (
                          <BsSortDown
                            onClick={() => sortCharged("total_paid")}
                          />
                        ) : (
                          <img
                            onClick={() => sortCharged("total_paid")}
                            src={sortImg}
                            alt="sort"
                          />
                        )}
                      </IconButton>
                    ) : (
                      <IconButton>
                        {bulkSort?.paid === 1 ? (
                          <BsSortDown onClick={() => handleBulkSort("paid")} />
                        ) : (
                          <img
                            src={sortImg}
                            alt="sort"
                            onClick={() => handleBulkSort("paid")}
                          />
                        )}
                      </IconButton>
                    )}
                  </TableCell>
                  {switchType !== "payment" && (
                    <TableCell
                      align="left"
                      className="paid-head"
                      style={{
                        paddingRight: "8rem",
                      }}
                    >
                      DUE
                      <IconButton
                        style={{
                          display: "none",
                        }}
                      >
                        {filters?.sort?.due === 1 ? (
                          <BsSortDown onClick={() => sortCharged("due")} />
                        ) : (
                          <img
                            onClick={() => sortCharged("due")}
                            src={sortImg}
                            alt="sort"
                          />
                        )}
                      </IconButton>
                    </TableCell>
                  )}
                  <TableCell className="ledger-head" align="left">
                    LEDGER / SUB LEDGER
                    {switchType !== "payment" ? (
                      <IconButton>
                        {filters?.sort?.ledger === 1 ? (
                          <BsSortDown onClick={() => sortCharged("ledger")} />
                        ) : (
                          <img
                            onClick={() => sortCharged("ledger")}
                            src={sortImg}
                            alt="sort"
                          />
                        )}
                      </IconButton>
                    ) : (
                      <IconButton>
                        {bulkSort?.ledger === 1 ? (
                          <BsSortDown
                            onClick={() => handleBulkSort("ledger")}
                          />
                        ) : (
                          <img
                            src={sortImg}
                            alt="sort"
                            onClick={() => handleBulkSort("ledger")}
                          />
                        )}
                      </IconButton>
                    )}
                  </TableCell>
                  {switchType === "payment" && (
                    <TableCell className="ledger-head" align="left">
                      PAYMENT METHOD
                      <IconButton>
                        {bulkSort?.paymentMethod === 1 ? (
                          <BsSortDown
                            onClick={() => handleBulkSort("paymentMethod")}
                          />
                        ) : (
                          <img
                            src={sortImg}
                            alt="sort"
                            onClick={() => handleBulkSort("paymentMethod")}
                          />
                        )}
                      </IconButton>
                    </TableCell>
                  )}
                  {switchType === "payment" && (
                    <TableCell className="ledger-head" align="left">
                      PAYMENT ID
                    </TableCell>
                  )}
                  <TableCell className={`empty-head ${switchType === "charge" ? "sticky-header-column" : ""}`} align="left" />
                </TableRow>
              </TableHead>
              <TableBody
                className="tran-table-body"
                style={{
                 
                  backgroundColor: "white",
                    ...(isEmbeddedInDialog
      ? {}
      : {           height: "500px",
        display: "contents" })
                }}
              >
                {finance === true && (
                  <TableRow>
                    <TableCell colSpan={12}>
                      <div className="tran-loader">
                        <Loader />
                      </div>
                    </TableCell>
                  </TableRow>
                )}

                {loading ? (
                  <TableRow>
                    <TableCell colSpan={12}>
                      <Loader />
                    </TableCell>
                  </TableRow>
                ) : productData?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={12}>
                      <div className="record-text">No record found</div>
                    </TableCell>
                  </TableRow>
                ) : productData ? (
                  productData?.map((row, i) => (
                    <ExpandableRow
                      batchbillingShow={batchbillingShow}
                      Enableloading={loading}
                      setcheckCreateAccount={setcheckCreateAccount}
                      checkCreateAccount={checkCreateAccount}
                      setPaymentAction={setPaymentAction}
                      setsavetribute={setsavetribute}
                      modifyRowData={modifyRowData}
                      key={row?._id ?? row?.charge?._id ?? i}
                      row={row}
                      index={i}
                      onCheckboxChange={onCheckboxChange}
                      page={page + 1}
                      check={check}
                      onSharePaymentLinkClick={onSharePaymentLinkClick}
                      onPayNowClick={onPayNowClick}
                      onUpdateClick={onUpdateClick}
                      onDeleteClick={onDeleteClick}
                      batchTable={batchTable}
                      onReversalClick={onReversalClick}
                      setDrawerData={setDrawerData}
                      setOpenModal={setOpenModal}
                      financeCheckIds={financeCheckIds}
                      paymentExpandable={paymentExpandable}
                      setPaymentExpandable={setPaymentExpandable}
                      setBatchList={setBatchList}
                      batchList={batchList}
                      transactionId={checkData.map((item) => {
                        return item?._id?.toString();
                      })}
                      checkData={checkData ?? checkData}
                      onPayAllClick={onPayAllClick}
                      bulkPayment={bulkPayment}
                      onCancelPayment={onCancelPayment}
                      onUpdatePaymentMethodClick={onUpdatePaymentMethodClick}
                      showSelection={showSelection}
  hideAccountName={!showAccountName}
                    />
                  ))
                ) : list?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={12}>
                      <div className="record-text">No record found</div>
                    </TableCell>
                  </TableRow>
                ) : list?.length > 0 && batchTable === "batchtable" ? (
                  list?.map((row, i) => (
                    <ExpandableRow
                      modifyRowData={modifyRowData}
                      key={row?._id ?? row?.charge?._id ?? i}
                      row={row}
                      index={i}
                      onCheckboxChange={onCheckboxChange}
                      page={page}
                      check={check}
                      onPayNowClick={onPayNowClick}
                      onReversalClick={onReversalClick}
                      setDrawerData={setDrawerData}
                      setOpenModal={setOpenModal}
                      batchTable={batchTable}
                      financeCheckIds={financeCheckIds}
                      batchList={batchList}
                      setBatchList={setBatchList}
                      transactionId={checkData.map((item) => {
                        return item?._id?.toString();
                      })}
                      checkData={checkData ?? checkData}
                      onPayAllClick={onPayAllClick}
                      onUpdatePaymentMethodClick={onUpdatePaymentMethodClick}
                      showSelection={showSelection}
  hideAccountName={!showAccountName}
                    />
                  ))
                ) : loading == true || finance === true ? (
                  <div className="tran-loader">
                    <Loader />
                  </div>
                ) : (
                  <></>
                )}
              </TableBody>
            </Table>
          </TableContainer>
       {showPagination &&  (isCountLoading && page === 0 ? (
            <div class="pagination-custom mt-2 align-items-center">
              <div class="arrow_btn">&#8249;</div>
              <CircularProgress size={18} className="mx-5" />
              <div class="arrow_btn">&#8250;</div>
            </div>
          ) : productData?.length === 0 && list === 0 ? (
            ""
          ) : (
            <>
              <div className="pagination-custom mt-2">
                <Pagination
                  count={Math.ceil(
                    (batchTable === "batchtable" ? batchDataCount : count) / 30
                  )}
                  color="primary"
                  variant="outlined"
                  page={page + 1}
                  onChange={(event, value) => {
                    setPage(value - 1);
                  }}
                />
              </div>
            </>
         ) )}
        </div>
        <AlertDialog
          open={openModalDialog}
          onDecline={() => {
            setOpenModalDialog(false);
          }}
          onAccept={() => {
            handleSubmit();
          }}
          title="Are you sure?"
          description={
            "Deleting this transaction is non-reversible. Would you like to proceed? "
          }
        />
        <AlertDialog
          open={showWarningDeleteDialog}
          onDecline={() => setShowWarningDeleteDialog(false)}
          onAccept={() => { handleSubmit(); }}
          acceptBtnText="Delete"
          title="Delete Charge"
          description={
            <div style={{ textAlign: 'left', color: '#002E5C' }}>
              <p style={{ marginBottom: '10px', fontWeight: '700' }}>This charge is already paid, reversed, or synced.</p>
              <p style={{ marginBottom: '10px' }}>Deleting it here will not update your accounting records in your accounting system.</p>
              <p style={{ marginBottom: '20px' }}>You are responsible for making any necessary changes directly in your accounting system.</p>
              <p style={{ fontWeight: '700' }}>Are you sure you want to delete this charge?</p>
            </div>
          }
        />
        <RightDrawer
          open={openModal}
          onClose={() => {
            setOpenModal(false);
            // if (chargeIdParams) {
            // setSearch_item_id(null);
            // }
          }}
        >
          <FinanceDrawer
            data={drawerData}
            setsavetribute={setsavetribute}
            handleClose={() => setOpenModal(false)}
            batchTable={batchTable}
            onReversalClick={onReversalClick}
            viewDocumentHandler={viewDocumentHandler}
            downloadFileHandler={downloadFileHandler}
            documentHandler={documentHandler}
            onSharePaymentLinkClick={onSharePaymentLinkClick}
            viewLetterHandler={viewLetterHandler}
            switchType={switchType}

          />
        </RightDrawer>
      </div>
      {/* View share email document  */}
      {openSharePaymentModal &&
        <Dialog
          open={openSharePaymentModal}
          onClose={() => {
            setOpenSharePayment(false);
          }}
          PaperProps={{
            style: {
              width: "888px",
              height: "637px",
              overflowX: "hidden",
              borderRadius: "22px",
            },
          }}
          fullWidth
          maxWidth={"md"}
        >
          <ShareDocumentsModal
            closeModal={() => {
              setOpenSharePayment(false);
            }}
            type={'sharePaymentLink'}
            accountId={dataRowSharePayment?.Account?.id}
            accountName={dataRowSharePayment?.Account?.name}
            chargeId={dataRowSharePayment?.charge?._id}
            defaultEmail={dataRowSharePayment?.Account?.defaultEmails || []}
            copyPaymentLink={copyPaymentLink}
            documentType="paymentLink"
          />
        </Dialog>
      }

      {openConfirmEditInstallmentModal &&
        <NewDialog
          isOpen={openConfirmEditInstallmentModal}
          handleClose={() => {
            confirmEditTransaction.current = false;
            setOpenConfirmEditInstallmentModal(false);
            setTransactionRowData({});
          }}
          content={<p
            style={{
              textTransform: "none"
            }}
          >This charge is currently associated with an active payment plan. Click ‘Confirm' to cancel the existing payment plan and proceed with the editing.</p>}
        >
          <div className="payment-modal">
            <button
              className="payment-modal-btn"
              onClick={() => {
                setOpenConfirmEditInstallmentModal(false);
                setTransactionRowData({});
              }}
            >
              Cancel
            </button>
            <button
              className="payment-modal-btn payment-modal-btn-primary"
              onClick={() => {
                confirmEditTransaction.current = true;
                onUpdateClick(transactionRowData);
                setOpenConfirmEditInstallmentModal(false);
              }}
            >
              Confirm
            </button>
          </div>
        </NewDialog>
      }
      <AlertDialog
        open={openConfirmCancelInstallmentModal}
        onDecline={() => {
          setTransactionRowData({});
          setOpenConfirmCancelInstallmentModal(false);
        }}
        onAccept={() => {
          confirmCancelInstallmentHandler()
        }}
        title="Are you sure?"
        description="Do you want to cancel the installments?"
      />
      <MyModal
        className={
          "new-charge-modal"
        }
        open={updatePaymentMethod.open}
        onClose={closeUpdatePaymentMethod}

      >
        <UpdatePaymentMethod
          title="Update Payment Information"
          closeModal={closeUpdatePaymentMethod}
          accountId={updatePaymentMethod?.data?.Account?.id}
          isInstallment={updatePaymentMethod?.data?.charge?.isInstallment && updatePaymentMethod?.data?.charge?.installmentDetails?.status === "active"}
          data={updatePaymentMethod?.data}
          reFetchData={getTransactionApiHandler}
        />
      </MyModal>

    </div>
  );
};

export default memo(ChargesTable);
